import { render } from "./CalendarButton.vue?vue&type=template&id=d1f53a6e"
import script from "./CalendarButton.vue?vue&type=script&lang=js"
export * from "./CalendarButton.vue?vue&type=script&lang=js"

import "./CalendarButton.vue?vue&type=style&index=0&id=d1f53a6e&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__